import { render, staticRenderFns } from "./projects.vue.html?vue&type=template&id=30ec6e6b&"
import script from "./projects.ts?vue&type=script&lang=ts&"
export * from "./projects.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports